var styles = {
  "Details": "Polaris-ActionMenu-MenuGroup__Details"
};

export { styles as default };
